import { IManufacturerSdResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    getManufacturersFilterParams,
    ManufacturersFilter,
} from 'custom_hooks/data_hooks/data_source/manufacturersDataSource';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { toDataSourceResult } from 'utils/query_v3';

export const ManufacturersDataSourceKey = 'manufacturers';

export type UseManufacturersDataSourceOptions = BaseDataSourceOptions<
    IManufacturerSdResponse,
    ManufacturersFilter
>;

export type ManufacturersDetailPagedDataSource = PagedDataSource<
    IManufacturerSdResponse,
    ManufacturersFilter
>;

export type ManufacturersDetailInfiniteDataSource = InfiniteDataSource<
    IManufacturerSdResponse,
    ManufacturersFilter
>;

const getAllManufacturers: DataSourceQuery<
    IManufacturerSdResponse,
    ManufacturersFilter
> = (params) => {
    const { filterExpr, orderBy, page, pageLimit } = getManufacturersFilterParams(
        params,
        true,
    );
    return toDataSourceResult(
        sdClient.sdGetManufacturers({
            filter: filterExpr,
            page,
            pageLimit,
            orderBy,
        }),
    );
};

export function usePagedManufacturersDetailDataSource({
    ...options
}: UseManufacturersDataSourceOptions): ManufacturersDetailPagedDataSource {
    return usePagedDataSource({
        ...options,
        query: getAllManufacturers,
    });
}

export function useInfiniteManufacturersDetailDataSource({
    ...options
}: UseManufacturersDataSourceOptions): ManufacturersDetailInfiniteDataSource {
    return useInfiniteDataSource({
        ...options,
        query: getAllManufacturers,
    });
}
